<script>
import {forEach as _forEach} from 'lodash'
import {lista, prerequisitosLista} from '../../../../domain/grv/services'
import {getLabel, GRV_DETRO} from '../../../../domain/grv/helpers/tipos-grv'
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'

const TIPO_REMOCAO_RODANDO = 2

export default {
  name: 'GrvListaMixins',
  mixins: [AclCheckMixins],
  data () {
    return {
      isLoading: false,
      isLoaded: false,
      paginationLimits: [25, 50, 100],
      pagination: {
        totalPages: 0,
        totalItems: 0,
        atualPage: 1,
        limit: 25
      },
      categorias: null,
      patios: null,
      checkeds: 0,
      checkedAll: false,
      arrayData: null,
      TIPO_REMOCAO_RODANDO
    }
  },
  computed: {
    noData () {
      if (this.arrayData === null) return false
      return this.arrayData.length === 0
    },
    categoriasFiltered () {
      if (+this.filtros.contrato !== 3) return this.categorias
      // Padrão TR ES
      this.categorias.splice(2, 1)
      return this.categorias.map((v, i) => ({ nome: v.traducao.es, id: v.id }))
    },
    tipoGrvLabel () {
      let {tipoGrv} = this.$route.query
      tipoGrv = tipoGrv || GRV_DETRO
      return getLabel(tipoGrv)
    }
  },
  methods: {
    start () {
      this.loadPreRequisitos()
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    loadData (limit, page, filtros) {
      this.arrayData = null
      this.isLoading = true
      lista(limit, page, filtros)
        .then((response) => {
          this.isLoading = false
          this.arrayData = response.data.arrayData
          this.pagination.atualPage = response.data.offset
          this.pagination.totalPages = response.data.totalPages
          this.pagination.totalItems = response.data.total
        })
        .catch((response) => {
          this.isLoading = false
          console.log(response)
        })
    },
    reloadData (dates = {}) {
      if (this.filtros.data === 'Periodo') {
        let {data1, data2} = dates
        if (!data1 || !data2) return
        this.filtros.data1 = data1
        this.filtros.data2 = data2
      } else {
        this.filtros.data1 = ''
        this.filtros.data2 = ''
      }
      console.log(this.filtros)
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    loadPreRequisitos () {
      prerequisitosLista(this.filtros.tipoGrv)
        .then((response) => {
          this.categorias = response.data.categorias
          this.patios = response.data.patios
          this.isLoaded = true
        })
        .catch((response) => {
          console.log(response)
        })
    },
    checkAll (o) {
      this.$nextTick(() => {
        let ca = this.checkedAll
        let _vm = this
        console.log(ca)
        if (ca === true) {
          console.log(ca, o.length)
          this.checkeds = o.length
        } else {
          this.checkeds = 0
        }
        _forEach(o, (item, key) => {
          _vm.$set(this.arrayData, key, Object.assign({}, this.arrayData[key], {selected: ca})) // Analisar desempenho
          // item.selected = ca
          // console.log(item)
        })
      })
    },
    lazyCheck: function (l) {
      this.$nextTick(() => {
        if (l.selected) {
          this.checkeds += 1
        } else {
          this.checkeds += -1
        }
        this.checkedAll = this.checkeds >= this.arrayData.length
      })
    },
    nextElement ({target}) {
      let index = parseInt(target.getAttribute('tabindex'))
      let next = index + 1
      document.querySelector('[tabindex="' + next + '"').focus()
    },
    podeMarcarChegou ({chegou, tipoRemocao}) {
      return this.possuiACL('pode_marcar_grv_chegou') && !chegou && tipoRemocao === TIPO_REMOCAO_RODANDO
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GrvListaMixins.vue?123acb4c